var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page text-pages privacy-page umowa-page"},[(_vm.instruction)?_c('div',{staticClass:"container"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.instruction.text)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }